import { Box, Button, Divider, Link, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PageTitle from "../PageTitle/PageTitle";
import { ASSETS_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import Datagrid from "../Datagrid/Datagrid";

const RequestHistoryDetails = ({ selectedRow = {}, setViewDetails, viewDetails }) => {
	const navigate = useNavigate();
	const [requestedProducts, setRequestedProducts] = useState([]);

	useEffect(() => {
		console.log(selectedRow);
		if (Object.keys(selectedRow).length > 0) {
			setRequestedProducts(selectedRow.products);
		}
	}, [selectedRow]);

	const formatDate = (dateString) => {
		const date = new Date(dateString);
		const month = `0${date.getMonth() + 1}`.slice(-2); // Get month (01-12)
		const day = `0${date.getDate()}`.slice(-2); // Get day (01-31)
		const year = date.getFullYear(); // Get full year
		const hours = `0${date.getHours()}`.slice(-2); // Get hours (00-23)
		const minutes = `0${date.getMinutes()}`.slice(-2); // Get minutes (00-59)
		const seconds = `0${date.getSeconds()}`.slice(-2); // Get minutes (00-59)

		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // Return formatted date
	};

	const columns = [
		{
			field: "product_name",
			headerName: "Part Name",
			flex: 1,
			renderCell: (params) => {
				const defaultImage = `${ASSETS_BASE_URL}/stock.png`;

				const handleError = (e) => {
					e.target.onerror = null; // Prevent infinite loop
					e.target.src = defaultImage; // Fallback to default image
				};

				const src = `${ASSETS_BASE_URL}/ProductImages/TMB/${params.row.product_number}.JPG`;

				return (
					<div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-start" }}>
						<img
							src={src}
							alt={params.row.product_name}
							onError={handleError}
							style={{
								width: "40px",
								height: "40px",
								objectFit: "cover",
								borderRadius: "4px",
							}}
						/>
						<div>
							<Link
								sx={{ cursor: "pointer" }}
								variant="body2"
								onClick={() => {
									navigate(`/machines/${params.row.machine_id}/${params.row.product_id}`);
								}}>
								{params.row.product_name}
							</Link>
						</div>
					</div>
				);
			},
		},
		{ field: "quantity", headerName: "Quantity", width: 170 },
		{ field: "product_number", headerName: "Part #", width: 200 },
		{ field: "machine_number", headerName: "Machine", width: 200 },
	];

	const handleCloseRequestHistoryDetails = () => {
		setViewDetails(false);
	};

	return (
		<Box>
			<Divider />
			<PageTitle title={`Request #: ${selectedRow?.request_number || ""}`} />
			<Box justifyContent={"flex-end"} display={"flex"} mb={1}>
				<Button variant="outlined" color="primary" onClick={handleCloseRequestHistoryDetails}>
					Close
				</Button>
			</Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					width: "100%",
					minHeight: "100px",
					height: "auto",

					columnGap: "16px",
				}}>
				<Box
					sx={{
						width: "100%",
						boxShadow: "0 0 10px 2px rgba(0,0,0,0.1)",
						borderRadius: "10px",
						p: 2,
						my: 1,
						minHeight: "100px",
						height: "100%",
					}}>
					<Typography color="primary" variant="h6" fontWeight={"bold"} mb={1}>
						Request Details
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>Requested #:</b> {selectedRow.request_number || ""}
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>Requested Date:</b> {formatDate(selectedRow.created) || ""}
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>Status:</b> {"Pending"}
					</Typography>
				</Box>
				<Box
					sx={{
						width: "100%",
						boxShadow: "0 0 10px 2px rgba(0,0,0,0.1)",
						borderRadius: "10px",
						p: 2,
						my: 1,
						height: "100%",
						minHeight: "100px",
					}}>
					<Typography color="primary" variant="h6" fontWeight={"bold"} mb={1}>
						User Details
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>Requested By:</b> {selectedRow.user_name || ""}
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>User Email:</b> {selectedRow.user_email || ""}
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>User Phone:</b> {selectedRow.user_phone || ""}
					</Typography>
				</Box>
				<Box
					sx={{
						width: "100%",
						boxShadow: "0 0 10px 2px rgba(0,0,0,0.1)",
						borderRadius: "10px",
						p: 2,
						my: 1,
						minHeight: "100px",
						height: "100%",
					}}>
					<Typography color="primary" variant="h6" fontWeight={"bold"} mb={1}>
						Customer Details
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>Customer Site Name:</b> {selectedRow.site_name || ""}
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>Customer Site Number:</b> {selectedRow.site_number || ""}
					</Typography>
					<Typography variant="body1" mb={"3px"}>
						<b>Shipping Address:</b> {selectedRow.address_full_ln || ""}
					</Typography>
				</Box>
			</Box>
			<Datagrid
				key="product_id"
				data={requestedProducts}
				columns={columns}
				rowClick={false}
				pageSize={5}
				showSearchBar={true}
				checkboxSelection={false}
				rowIdField="product_id"
				sortBy={[{ field: "product_name", sort: "asc" }]}
			/>
			<Box justifyContent={"center"} display={"flex"}>
				<Button variant="outlined" color="primary" onClick={handleCloseRequestHistoryDetails}>
					Close
				</Button>
			</Box>
		</Box>
	);
};

export default RequestHistoryDetails;
